import useIsMobile from '@/hooks/use-is-mobile';
import { PlacementWithLogical, ResponsiveValue } from '@chakra-ui/react';
import { IconInfoCircle, IconSize, Popover, Text } from '@cmpsr/components';

export const InfoPopover = ({
  popoverContent,
  color = 'white-50',
  iconSize = 's',
  placement = 'bottom',
}: {
  popoverContent: string;
  color: string;
  iconSize?: ResponsiveValue<IconSize>;
  placement?: PlacementWithLogical;
}) => {
  const isMobile = useIsMobile();
  return (
    <Popover
      trigger={isMobile ? 'click' : 'hover'}
      closeOnBlur
      placement={placement}
      arrowShadowColor="var(--chakra-colors-medBlue)"
    >
      <Popover.Trigger>
        <IconInfoCircle size={iconSize} color={color} />
      </Popover.Trigger>
      <Popover.Content backgroundColor="darkBlueTransparent" borderColor="medBlue">
        <Popover.Arrow backgroundColor="darkBlueTransparent" />
        <Popover.Body borderRadius="radii-1" py={5} px={3}>
          <Text variant="text-body-floating-label-regular" color="text-primary-negative">
            {popoverContent}
          </Text>
        </Popover.Body>
      </Popover.Content>
    </Popover>
  );
};
